import React, { PropsWithChildren } from 'react';

import { bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'container';

interface Props {
	fluid: boolean;
	lg: boolean;
	md: boolean;
	sm: boolean;
	xl: boolean;
}

function Container(props: PropsWithChildren<Props>): JSX.Element {
	const { children, fluid, sm, md, lg, xl } = props;

	return <div className={bm(MODULE_NAME, { fluid, sm, md, lg, xl })}>{children}</div>;
}

export default Container;
